<template>
  <a
    :href="link"
    :aria-label="title"
    class="press-releases__item"
  >
    <div class="press-releases__text">
      <p class="press-releases__title">
        <slot name="title" />
        {{ title }}
      </p>
      <p class="press-releases__description">
        <slot name="text" />
        {{ text }}
      </p>
    </div>
    <div class="press-releases__info">
      <p class="press-releases__date">
        <slot name="date" />
        {{ date }}
      </p>
      <p
        v-for="(category, index) in categories"
        v-show="currentCategory === index"
        :key="index"
        class="press-releases__category"
      >
        {{ category }}
      </p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'press-item',
  props: {
    title: {
      type: String,
    },
    link: {
      type: String,
    },
    text: {
      type: String,
    },
    date: {
      type: String,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentCategory: 0,
    }
  },
  mounted() {
    if (this.categories.length > 0) {
      this.startCategoryRotation()
    }
  },
  beforeUnmount() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval)
    }
  },
  methods: {
    startCategoryRotation() {
      this.rotationInterval = setInterval(() => {
        this.currentCategory = (this.currentCategory + 1) % this.categories.length
      }, 5000)
    },
  },
}
</script>
